// Set up I18n-js
import { I18n } from "i18n-js";
import translations from "./translations.json";

const i18n = new I18n(translations);
i18n.defaultLocale = "da"
i18n.locale = document.documentElement.lang

export { i18n }
